<template>
  <div class="cover-div h5-form" v-if="show">
    <div class="inner-div">
      <div class="el-dialog__header">
        <button type="button" aria-label="Close" class="el-dialog__headerbtn" @click="() => $emit('close')">
          <i class="el-dialog__close el-icon el-icon-close"></i>
        </button>
      </div>
      <div class="toTry" :style="styleObj">
        <div class="try-tit">免费试用</div>
        <div class="line">
          <input
            :class="[(isClick && name == '') || name == '请输入您的姓名(中文)' ? 'active_input' : '']"
            v-model="name"
            type="text"
            class="userName"
            placeholder="您的姓名"
            @focus="clearData(0)"
            @blur="onfousFun()"
          />
        </div>
        <div class="line">
          <input
            :class="[(isClick && companyName == '') || companyName == '请输入公司名称(中文)' ? 'active_input' : '']"
            v-model="companyName"
            type="text"
            class="companyName"
            placeholder="公司名称"
            @focus="clearData(1)"
            @blur="onfousFun()"
          />
        </div>
        <div class="line">
          <input
            :class="[(isClick && phoneNumber == '') || phoneNumber == '请输入您的联系方式' ? 'active_input' : '']"
            v-model="phoneNumber"
            id="mobile"
            type="text"
            class="mobile"
            placeholder="手机号码"
            @focus="clearData(2)"
            @blur="onfousFun()"
          />
        </div>

        <div class="line">
          <div class="code-box code-box-boder">
            <input
              :class="[(isClick && phoneCode == '') || phoneCode == '请输入验证码' ? 'active_input' : '']"
              v-model="phoneCode"
              maxlength="6"
              type="text"
              class="code-input form-control code no_border"
              placeholder="验证码"
              @focus="clearData(3)"
              @blur="onfousFun()"
            />
            <span
              :class="[codeName == '获取验证码' ? 'active_c1' : 'active_c']"
              class="code-btn"
              id="code-btn"
              @click="handleFetchCodeClick()"
              >{{ codeName }}</span
            >
          </div>
        </div>
        <div class="line agreement-line" v-if="userAgreement.enable">
          <label class="wrapper">
            <input type="checkbox" v-model="agreement" /><span>我已阅读并同意<a :href="userAgreement.link" target="_blank">《隐私协议》</a></span>
          </label>
          <div v-show="showErrorTip" class="error-tip">请先阅读并同意协议</div>
        </div>
        <div class="line bot-container">
          <div id="man-machine-slide"></div>
        </div>
        <div class="btn-try" :class="changeBtnBg ? 'bg_active1' : 'bg_active0'" @click="handleSendInfoBtnClick()">
          提交试用信息
        </div>
        <!-- <a name="reg-pc" :href="`https://h5.esign.cn/usercenterFront/regist?pub=${pub}`" class="btn_zc">注册体验</a> -->
      </div>
    </div>
  </div>
</template>

<script>
import formMixin from '../mixins/form.js'

export default {
  mixins: [formMixin],
  props: {
    show: Boolean,
  },
  data() {
    return {
      isH5: true,
      styleObj: {
        height: document.body.clientHeight,
      },
    }
  },
  watch: {
    show(val) {
      if (!val) this.reset()
    },
  },
}
</script>

<style lang="less" scoped>
.h5-form {
  /deep/ .el-dialog {
    border-radius: 10px;
  }

  /deep/ .el-dialog__header {
    padding: 0;
    height: 28px;
  }

  /deep/ .el-dialog__headerbtn {
    top: 10px;
  }

  /deep/ .el-dialog__close {
    font-size: 12px;
  }

  /deep/ .el-dialog__body {
    padding: 0 0 21px;
  }

  .title {
    width: 489px;
    height: 227px;
    background-image: url(https://pro-web-static.oss-cn-hangzhou.aliyuncs.com/tsignWeb/images/common/banner_text.png);
    background-size: contain;
    background-repeat: no-repeat;
    margin-top: 127px;
  }

  .toTry {
    font-size: 16px;
  }

  a {
    display: block;
    text-decoration: none;
  }

  .line {
    width: 300px;
    height: 40px;
    position: relative;
    margin: 0 auto 16px;

    .form-control.code {
      width: 170px !important;
      padding-left: 20px !important;
    }

    .active_c {
      color: #ccc;

      &1 {
        color: #297acc;
      }
    }
  }

  .code-box {
    position: relative;

    .no_border {
      border: 0;
      box-shadow: none !important;

      &:focus {
        box-shadow: none;
        border-color: #fa485a;
      }
    }
  }

  .code-box-boder {
    border: 1px solid #ebebeb;
  }

  .code-btn {
    width: 113px;
    height: 40px;
    border-radius: 2px;
    position: absolute;
    text-align: right;
    right: 20px;
    top: 0;
    bottom: 0;
    font-size: 14px;
    font-family: MicrosoftYaHei;
    font-weight: 400;
    line-height: 40px;

    &.disabled {
      background: #ccc;
      color: #fff;
    }
  }

  .active_input {
    border: 1px solid #e61717;
    color: #e61717;
  }

  .bg_active0 {
    background: #e61717 !important;
  }
  .bg_active1 {
    background: rgba(230, 23, 23, 0.5) !important;
  }

  input {
    font-size: 14px;
    font-family: PingFangSC-Regular;
    width: 100%;
    display: block;
    height: 40px;
    border: 1px solid #e4e4e4;
    padding: 6px 20px;
    color: #333;
    outline: 0;

    &::placeholder {
      color: #4d4d4d;
    }
  }

  .btn_zc {
    width: 300px;
    height: 20px;
    line-height: 20px;
    margin: 0 auto;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    font-family: PingFangSC-Regular;
    color: #297acc;
  }

  .active_input {
    border: 1px solid #e61717;
    color: #e61717;
  }

  .try-tit {
    font-size: 18px;
    font-family: PingFangSC-Medium;
    color: #333;
    line-height: 25px;
    font-weight: 700;
    margin-bottom: 17px;
    text-align: center;
  }

  .btn-try {
    width: 300px;
    height: 42px;
    border-radius: 3px;
    margin: 0 auto 17px;
    text-align: center;
    line-height: 42px;
    font-size: 14px;
    color: #fff;
  }

  .bot-container {
    height: auto;
  }
  .agreement-line {
    height: auto;
    color: #000;
    padding-bottom: 6px;
    .wrapper {
      display: flex;
      align-items: center;
    }
    input {
      width: 14px;
      height: 14px;
      display: inline-block;
      flex-grow: 0;
    }
    span {
      font-size: 13px;
      margin-left: 6px;
    }
    a {
      display: inline-block;
      font-size: 13px;
      color: #1890ff;
    }
    .error-tip {
      font-size: 12px;
      color: red;
      position: absolute;
      bottom: -12px;
    }
  }
}
.cover-div {
  position: fixed;
  width: 100vw;
  top: 0;
  bottom: 0;
  /* 使之可以滚动 */
  overflow-y: scroll;
  /* 增加该属性，可以增加弹性 */
  -webkit-overflow-scrolling: touch;
  background: rgba(0, 0, 0, 0.6);
  z-index: 2001;
  display: flex;
  justify-content: center;
  align-items: center;
  .inner-div {
    width: 90%;
    border-radius: 10px;
    position: relative;
    margin: 0 auto 50px;
    padding-bottom: 20px;
    background: #fff;
    border-radius: 10px;
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
}
</style>

<style lang="less">
@import '../mixins/bot.less';

.h5-form {
  .bot_slide_h5(
    @slideHeight: 40px,
    @okIconColor: #37c780,
    @placeholderColor: #1a1a1a,
    @placeholderFontWeight: 400,
    @arrowSize: 14px,
    @arrowColor: #979797
  );
}
</style>
